<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-3">
          <v-alert
            color="primary"
            text
            icon="mdi-file-document-outline"
            type="info"
            border="bottom"
            >NOTAS SAÍDAS</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>
    <v-row class gutters>
      <v-col cols="12" xl="2" lg="2" md="2" sm="3" xs="3">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateIniFormatted"
              label="Data Inicial"
              hint
              persistent-hint
              prepend-inner-icon="event"
              outlined
              dense
              @blur="date_ini = parseDate(dateIniFormatted)"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="pt-br"
            v-model="date_ini"
            no-title
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" xl="2" lg="2" md="2" sm="3" xs="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFimFormatted"
              label="Data Final"
              persistent-hint
              prepend-inner-icon="event"
              readonly
              outlined
              dense
              v-on="on"
              @blur="date_fim = parseDate(dateFimFormatted)"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="pt-br"
            v-model="date_fim"
            no-title
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
        <p></p>
      </v-col>

      <v-col cols="12" xl="2" lg="2" md="2" sm="3" xs="12">
        <v-btn
          tile
          class="ma-0 white--text"
          :loading="loading_filtrar"
          :disabled="loading_filtrar"
          color="botao_sucesso"
          @click="buscaNotas()"
        >
          Filtrar
          <v-icon right light>mdi-filter-outline</v-icon>
        </v-btn>
      </v-col>
      <v-col class="pb-15" cols="12" xl="2" lg="2" md="2" sm="3" xs="12">
        <v-btn
          tile
          class="ma-0 white--text"
          :loading="loading_baixar"
          :disabled="loading_baixar"
          color="botao_sucesso"
          @click="baixar_notas()"
        >
          Baixar Notas do Período
          <v-icon right light>mdi-cloud-download</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Pesquisar"
          filled
          dense
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading_table"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
        <template v-slot:item.status="{ item }">
          <span class="cancelada">{{ item.status }}</span>
        </template>
      </v-data-table>
    </v-card>
    <a href="#" target="_blank" id="linkDownload" download></a>
  </v-container>
</template>

<script>
var moment = require("moment");

const auth = {
  headers: {
    Authorization: "bearer " + window.sessionStorage.getItem("token"),
  },
};
export default {
  props: {
    source: String,
  },
  mounted() {
    this.buscaNotas();
  },
  data: (vm) => ({
    date_ini: moment().format("YYYY-MM-01"),
    date_fim: new Date().toISOString().substr(0, 10),
    dateFimFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dateIniFormatted: moment().format("01/MM/YYYY"),
    menu1: false,
    menu2: false,
    loading_table: false,
    headers: [],
    search: "",
    loading_filtrar: false,
    loading_baixar: false,
    items: [],
    headers: [
      {
        text: "Chave",
        sortable: true,
        align: "left",
        value: "chave",
      },
      {
        text: "Data",
        value: "data",
      },
      {
        text: "Número",
        value: "nf_numero",
        align: "right",
      },
      {
        text: "Valor",
        value: "valor",
        align: "right",
      },
      {
        text: "Base",
        value: "base",
        align: "right",
      },
      {
        text: "Status",
        value: "status",
        sortable: false,
      },
    ],
  }),
  computed: {
    computedDateInFormatted() {
      return this.formatDate(this.date_ini);
    },
    computedDateFimFormatted() {
      return this.formatDate(this.date_fim);
    },
  },

  watch: {
    date_ini(val) {
      this.dateIniFormatted = this.formatDate(this.date_ini);
    },
    date_fim(val) {
      this.dateFimFormatted = this.formatDate(this.date_fim);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getStatus(status) {
      if (status === "Cancelada") {
        return "cancelada";
      }
    },
    baixar_notas() {
      this.loading_baixar = true;

      axios
        .post(`/nfs/arquivos/baixar`, {
          cnpj: window.sessionStorage.getItem("cnpj"),
          data_ini: this.date_ini,
          data_fim: this.date_fim,
        })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.loading_baixar = false;
            setTimeout(() => {
              document.getElementById("linkDownload").href = response.data.url;
              //document.getElementById("linkDownload").download =
              // '"http://192.168.1.135:75/GKFq70ibiI38urfHml.pdf"';
              document.getElementById("linkDownload").click();
            }, 600);
          }
        });
    },
    buscaNotas() {
      this.loading_filtrar = true;
      this.loading_table = true;
      axios
        .post(
          `/nfs/lista`,
          {
            cnpj: window.sessionStorage.getItem("cnpj"),
            data_ini: this.date_ini,
            data_fim: this.date_fim,
          },
          auth
        )
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.loading_table = false;
            this.loading_filtrar = false;
            this.items = response.data;
          }
        });
    },
  },
};
</script>
<style scoped>
.cancelada {
  color: red;
}
</style>
